import { color, spacing, typography } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Inner = styled.div``

export const HeadingText = styled.h2`
  ${typography('headline2')}
  color: ${color('blue.01')};
`

export const NumberText = styled.span`
  ${typography('body2')}
  color: ${color('gray.01')};
  display: flex;
  align-items: center;

  &::after {
    content: '';
    display: block;
    width: 12px;
    border-bottom: 1px solid ${color('gray.01')};
    margin-left: 2px;
  }
`

export const Subheading = styled.span`
  ${typography('body2')}
  color: ${color('gray.01')};
  text-align: center;
  display: block;

  &::before {
    content: '[';
    margin-right: ${spacing(1)};
  }

  &::after {
    content: ']';
    margin-left: ${spacing(1)};
  }
`
